import { Box } from '@mui/material';

// Define the allowed shape types
export type ShapeType = 'circle' | 'square' | 'triangle' | 'hexagon' | 'pentagon';

// Define props interface for the component
interface ShapeIconProps {
  shape?: ShapeType;
  size?: number;
  color?: string;
}

// SVG paths for custom shapes
const shapePaths: Record<ShapeType, string> = {
  circle: 'M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z',
  square: 'M3,3v18h18V3H3z',
  triangle: 'M12 2L2 22h20L12 2z',
  hexagon: 'M23,12l-5.5,9.5h-11L1,12l5.5-9.5h11L23,12z',
  pentagon: 'M12 1L2 10L4 22h16l2-12L12 1z',
};

// ShapeIcon component that renders different shapes based on the prop
const ShapeIcon = ({
  shape = 'circle',
  size = 12,
  color = 'currentColor',
  ...props
}: ShapeIconProps): JSX.Element => {
  // For custom SVG shapes
  const path = shapePaths[shape as Exclude<ShapeType, 'circle' | 'square'>];
  if (path) {
    return (
      <Box
        component="svg"
        viewBox="0 0 24 24"
        style={{ height: size, width: size, fill: color }}
        {...props}
      >
        <path d={path} />
      </Box>
    );
  }

  // Default fallback
  return <></>;
};

export default ShapeIcon;
